/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PurchaseMissionClonePayloadModel model module.
 * @module model/PurchaseMissionClonePayloadModel
 * @version v1.0.0
 */
class PurchaseMissionClonePayloadModel {
    /**
     * Constructs a new <code>PurchaseMissionClonePayloadModel</code>.
     * @alias module:model/PurchaseMissionClonePayloadModel
     */
    constructor() { 
        
        PurchaseMissionClonePayloadModel.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PurchaseMissionClonePayloadModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PurchaseMissionClonePayloadModel} obj Optional instance to populate.
     * @return {module:model/PurchaseMissionClonePayloadModel} The populated <code>PurchaseMissionClonePayloadModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PurchaseMissionClonePayloadModel();

            if (data.hasOwnProperty('customerId')) {
                obj['customerId'] = ApiClient.convertToType(data['customerId'], 'Number');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} customerId
 */
PurchaseMissionClonePayloadModel.prototype['customerId'] = undefined;

/**
 * @member {String} description
 */
PurchaseMissionClonePayloadModel.prototype['description'] = undefined;

/**
 * @member {String} title
 */
PurchaseMissionClonePayloadModel.prototype['title'] = undefined;






export default PurchaseMissionClonePayloadModel;

